import { Typography } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import parse from 'html-react-parser';
import { useState } from 'react';

import ModalMedia from './ModalMedia';

const MediaInfos = ({
  item,
  data,
  imageInfo,
  index,
  info,
  page,
  isFirst,
  isLast,
}) => {
  const {
    css,
    classes,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);
  const [openMedia, setOpenMedia] = useState(false);
  const [swipIndex, setswipIndex] = useState(0);

  const openMediaModal = () => {
    setswipIndex(index + (page - 1) * 3);
    setOpenMedia(true);
  };

  const closeMediaModal = () => {
    setOpenMedia(false);
  };

  return (
  <> {/* Nécessaire pour pouvoir fermer la modale avec un clique (je suis tout aussi confus que toi)*/}
    <div className={classes.container} onClick={openMediaModal}>
      <div
        className={cx(
          classes.leftPan,
          css({
            backgroundImage:
              item?.type === 'image'
                ? `url(${item?.path})`
                : `url(https://img.youtube.com/vi/${item?.path}/maxresdefault.jpg)`,
          })
        )}
      />
      <div className={classes.rightPan}>
        <div>
          <Typography className={cx(global.title, classes.mediaTitle)}>{item?.label}</Typography>
        </div>
        <div className={classes.mediaParagraph}>{parse(item?.description)}</div>
      </div>
    </div>
    <ModalMedia
      closeMediaModal={closeMediaModal}
      openMedia={openMedia}
      data={data}
      imageInfo={imageInfo}
      info={info}
      swipIndex={swipIndex}
    />
  </>
  );
};

const styles = ({ spacing }) => ({
  container: {
    width: '49%',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: 10,
    backgroundColor: 'white',
    cursor: 'pointer',
    height: '100%',
    border: '1px solid #C0D9FF',
    transition: 'all 0.2s',
    '&:hover': {
      transition: 'all 0.2s',
      border: '1px solid #0060F9',
      '.MuiTypography-body1': {
        transition: 'all 0.2s',
        color: '#0060F9',
      },
    },
    '@media (max-width:1520px)': { width: '48.7%' },
    '@media (max-width:1280px)': { width: '100%' },
  },
  mediaTitle: {
    color: '#5D75A8',
    fontWeight: '400',
    textAlign: 'start',
    marginBottom: '8px'
  },
  mediaParagraph: {
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    color: '#152652',
    textAlign: 'start',
    marginTop: 0,
    lineHeight: '20px',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-box-orient': 'vertical',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '& > p': {
      margin: 0,
    },
  },
  rightPan: {
    width: '65%',
    padding: spacing(2),
    '@media (max-width:768px)': { width: '100%' },
  },
  leftPan: {
    width: '35%',
    height: '120px',
    borderRadius: '10px 0px 0px 10px',
    padding: spacing(2),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '@media (max-width:768px)': { minHeight: '10vh' },
  },
});

export default MediaInfos;
